import type { SnowflakeTableFqn } from 'app/lib/types/server';
import { matches } from './stringMatches';

export const matchesSnowflakeFQN = (entity: SnowflakeTableFqn, textFilter: string): boolean => {
    const { database, schema, table } = entity;
    const filterComponents = textFilter.split('.');

    if (filterComponents.length === 1) {
        return (
            matches(database, filterComponents[0]!) ||
            matches(schema, filterComponents[0]!) ||
            matches(table, filterComponents[0]!)
        );
    } else if (filterComponents.length === 2) {
        return (
            (matches(database, filterComponents[0]!) && matches(schema, filterComponents[1]!)) ||
            (matches(database, filterComponents[0]!) && matches(table, filterComponents[1]!)) ||
            (matches(schema, filterComponents[0]!) && matches(table, filterComponents[1]!))
        );
    } else if (filterComponents.length === 3) {
        return (
            matches(database, filterComponents[0]!) &&
            matches(schema, filterComponents[1]!) &&
            matches(table, filterComponents[2]!)
        );
    }
    return false;
};
